<!-- start table -->
<div class="bettingTable" [ngClass]="betData.side.includes('b') ? 'back' : 'lay'" *ngIf="betData && betData?.price && betData?.isClosed == false">
    <div class="row justify-content-end py-1">
        <div class="col-md-8">
            <div class="row">
                <div class="col-md-2 px-0 mbetting-table-none">
                    <button class="btn btn-cancel" (click)="onCloseBet($event)">cacnel</button>
                </div>
                <div class="col-md-7 px-0">
                    <div class="row">
                        <div class="col-md-7 col-6 px-1">
                            <div class="input-group">
                                <div class="input-group-prepend" (click)="onChangeOdds('down')">
                                    <span class="input-group-text">
                                        <i class="mdi mdi-minus"></i>
                                    </span>
                                </div>
                                <input type="number" class="form-control"  [(ngModel)]="betData.price" (change)="validateField()" min="1.01" max="999.99">
                                <div class="input-group-append" (click)="onChangeOdds('up')">
                                    <span class="input-group-text">
                                        <i class="mdi mdi-plus"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-5 col-6 px-1">
                            <input type="number" class="form-control mbetting-table-none" (keypress)="digitOnly($event)" (keydown)="validateField()"
                            (keyup)="validateField()" (change)="validateField()" [(ngModel)]="betData.stake" min="0"
                            placeholder="Min: 000">
                            <div class="input-group dbetting-table-none">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <i class="mdi mdi-minus"></i>
                                    </span>
                                </div>
                                <input type="number" class="form-control" (keypress)="digitOnly($event)" (keydown)="validateField()"
                                (keyup)="validateField()" (change)="validateField()" [(ngModel)]="betData.stake" min="0"
                                placeholder="Min: 000">
                                <div class="input-group-append">
                                    <span class="input-group-text">
                                        <i class="mdi mdi-plus"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 mbetting-table-none">
                    <button class="btn btn-betplace" [disabled]="betData.disabled" (click)="orderPlaced()">betplace</button>
                </div>
            </div>
        </div>
    </div>
    <div class="row justify-content-center py-1">
        <ul class="stakesBtns mbetting-table-none">
            <li *ngFor="let stk of betData.stakes;"><a class="btn" (click)="onAmountChange(stk)">{{stk.name}}</a></li>
        </ul>

        <div class="col-12 dbetting-table-none">
            <div class="m_stakesBtns">
                <a class="btn" *ngFor="let stk of betData.stakes;" (click)="onAmountChange(stk)">{{stk.name}}</a>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-6 dbetting-table-none pr-xs-1">
            <button class="btn btn-cancel" (click)="onCloseBet($event)">cacnel</button>
        </div>
        <div class="col-6 dbetting-table-none pl-xs-1">
            <button class="btn btn-betplace" [disabled]="betData.disabled" (click)="orderPlaced()">betplace</button>
        </div>
    </div>
</div>
<!-- end table -->
<app-loader class="full-overlay" *ngIf="isLoading"></app-loader>